// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBkhKh56pLJZ7AM59s03NlEL5_ZBv-M9Ec",
  authDomain: "adhd-app-f6232.firebaseapp.com",
  projectId: "adhd-app-f6232",
  storageBucket: "adhd-app-f6232.firebasestorage.app",
  messagingSenderId: "472931496901",
  appId: "1:472931496901:web:f7d9fb93befaa3c9a191ac"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { app, analytics, auth, db }; 